import { put, call, fork, select, takeEvery, all } from 'redux-saga/effects';
import { reset as resetForm } from 'redux-form';

import * as playablesModule from '../modules/playables.module';
import * as Api from '../../core/api';

export function* fetchPlayables({ payload: { page, itemsPerPage } }) {
  const sort = yield select((state) => state.playables.sort);
  const filter = yield select((state) => state.playables.filter);
  const { response, error } =
    yield call(Api.playables.fetchPlayables, { page, itemsPerPage, sort, filter });

  if (response) {
    yield put(playablesModule.fetchPlayablesSuccess(response));
  } else {
    yield put(playablesModule.fetchPlayablesFail(error));
  }
}
export function* watchFetchPlayables() {
  yield takeEvery(playablesModule.fetchPlayables.getType(), fetchPlayables);
}

export function* addPlayable({ payload: playable }) {
  const { response, error } = yield call(Api.playables.addPlayable, playable);

  if (response) {
    yield put(playablesModule.addPlayableSuccess(response));
    yield put(playablesModule.closeUpdatePlayable());
    yield put(resetForm('addPlayable'));
  } else {
    yield put(playablesModule.addPlayableFail(error));
  }
}
export function* watchAddPlayable() {
  yield takeEvery(playablesModule.addPlayable.getType(), addPlayable);
}

export function* updatePlayable({ payload: { playableId, playable } }) {
  const { response, error } = yield call(Api.playables.updatePlayable, { playableId, playable });

  if (response) {
    yield put(playablesModule.updatePlayableSuccess({ playableId, playable: response }));
    yield put(playablesModule.closeUpdatePlayable());
    yield put(resetForm('addplayable'));
  } else {
    yield put(playablesModule.updatePlayableFail(error));
  }
}
export function* watchUpdatePlayable() {
  yield takeEvery(playablesModule.updatePlayable.getType(), updatePlayable);
}

export default function* watchPlayables() {
  return yield all([
    fork(watchFetchPlayables),
    fork(watchAddPlayable),
    fork(watchUpdatePlayable),
  ]);
}




/** WEBPACK FOOTER **
 ** ./js/redux/saga/playables.saga.js
 **/